import React from 'react'
import cn from 'classnames'
import { Link, useNavigate, useParams } from 'react-router-dom'

import { WidgetLayout } from '../../../lib/widget-layout'
import { Table, TableHeader, TableRow, TableHeaderCell, TableBody, TableBodyCell } from '../../../lib/table'
import Text from '../../../ui/Text'
import { Button } from '../../../lib/button'
import isAura from '../../../lib/isAura'
import { ChargePoint } from '../../../common/redux/api/web-api'

export type AdminUserAccessToChargersWidgetProps = {
    chargePoints: ChargePoint[]
    isAdmin: boolean
    dataLoadingChargePoints: boolean
    style?: React.CSSProperties
}

export const AdminUserAccessToChargersWidget = React.memo(function AdminUserAccessToChargersWidget({
    chargePoints,
    isAdmin,
    dataLoadingChargePoints,
    style,
}: AdminUserAccessToChargersWidgetProps): React.ReactElement {
    const { id: userId } = useParams()
    const navigate = useNavigate()
    return (
        <div style={style}>
            <WidgetLayout
                title={<Text code="lblRFIDAccessToChargers"></Text>}
                className={cn({ widgetprocessing: dataLoadingChargePoints })}
                headerButtons={[
                    isAdmin ? (
                        <Button
                            code="btnEdit"
                            small
                            onClick={() => navigate(`/user/${userId}/userChargePoints`)}
                            dataTestId="btn-edit"
                        ></Button>
                    ) : (
                        <></>
                    ),
                ]}
                data-testid="access-chargers"
            >
                <Table data-testid="access-chargers-table">
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell data-testid="lbl-id">
                                <Text code="lblId"></Text>
                            </TableHeaderCell>
                            <TableHeaderCell data-testid="lbl-name">
                                <Text code="lblName"></Text>
                            </TableHeaderCell>
                            <TableHeaderCell data-testid="lbl-sockets">
                                <Text code="lblSockets"></Text>
                            </TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {chargePoints?.map((chargePoint) => (
                            <TableRow key={chargePoint.id} data-testid={`row-${chargePoint.id}`}>
                                <TableBodyCell>
                                    <Link
                                        className="btn-link"
                                        to={`/chargepoints/${chargePoint.id}`}
                                        data-testid="btn-link"
                                    >
                                        {chargePoint.id}
                                    </Link>
                                </TableBodyCell>
                                <TableBodyCell data-testid={`name-${chargePoint.id}`}>{chargePoint.name}</TableBodyCell>
                                <TableBodyCell data-testid={`socket-${chargePoint.id}`}>
                                    {!isAura(chargePoint) && <span className="fa fa-circle"></span>}
                                    {isAura(chargePoint) && (
                                        <span>
                                            {chargePoint.connectors?.map((connector) =>
                                                connector.hasNfcAccess ? (
                                                    <span
                                                        key={connector.connectorId}
                                                        data-testid="users-has-nfc-access"
                                                        className="fa fa-circle margin-right-2"
                                                    ></span>
                                                ) : (
                                                    <span
                                                        key={connector.connectorId}
                                                        data-testid="users-has-no-nfc-access"
                                                        className="fa fa-circle-o"
                                                    ></span>
                                                )
                                            )}
                                        </span>
                                    )}
                                </TableBodyCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </WidgetLayout>
        </div>
    )
})
